import { useEffect, useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { LogOut, Menu, X } from 'lucide-react';

const Header = () => {
    const [selectedMenuName, setSelectedMenuName] = useState('');
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();

    const updateMenuName = () => {
        const menuName = localStorage.getItem('selectedMenuName') || '';
        setSelectedMenuName(menuName);
    };

    // Initial load
    useEffect(() => {
        updateMenuName();
    }, []);

    // Listen for storage changes
    useEffect(() => {
        const handleStorageChange = (e) => {
            if (e.key === 'selectedMenuName') {
                setSelectedMenuName(e.newValue || '');
            }
        };

        window.addEventListener('storage', handleStorageChange);
        return () => {
            window.removeEventListener('storage', handleStorageChange);
        };
    }, []);

    // Custom event listener voor directe updates
    useEffect(() => {
        const handleMenuChange = () => {
            updateMenuName();
        };

        window.addEventListener('menuChanged', handleMenuChange);
        return () => {
            window.removeEventListener('menuChanged', handleMenuChange);
        };
    }, []);

    useEffect(() => {
        setIsMenuOpen(false);
    }, [location]);

    const handleLogout = () => {
        localStorage.removeItem('token');
        localStorage.removeItem('refreshToken');
        localStorage.removeItem('expiresIn');
        localStorage.removeItem('selectedMenu');
        localStorage.removeItem('selectedMenuName');
        navigate('/');
    };

    const navLinks = [
        { to: "/dashboard", label: "HOME" },
        { to: "/categories", label: "CATEGORIEEN" },
        { to: "/dishes", label: "GERECHTEN" },
        { to: "/products", label: "PRODUCTEN" },
        { to: "/more", label: "MEER" }
    ];

    return (
        <header className="w-full fixed bg-white shadow-sm z-50">
            <div className="max-w-[1100px] mx-auto px-4">
                {/* Desktop Header */}
                <div className="hidden md:flex justify-between items-center py-4">
                    <h1 className="text-2xl font-normal font-inter text-ps-blue-dark">
                        PS IN FOODSERVICE
                    </h1>
                    <div className="flex items-center gap-4">
                        {selectedMenuName && (
                            <span className="text-ps-blue-dark font-inter">
                                {selectedMenuName}
                            </span>
                        )}
                        <button
                            onClick={handleLogout}
                            className="p-2 text-ps-blue hover:text-ps-blue-dark transition-colors"
                            title="Uitloggen"
                        >
                            <LogOut size={24} />
                        </button>
                    </div>
                </div>

                {/* Mobile Header */}
                <div className="md:hidden">
                    <div className="flex justify-between items-center py-4">
                        <div className="flex flex-col">
                            <h1 className="text-xl font-normal font-inter text-ps-blue-dark">
                                PS IN FOODSERVICE
                            </h1>
                            {selectedMenuName && (
                                <span className="text-ps-blue-dark font-inter text-sm mt-1">
                                    {selectedMenuName}
                                </span>
                            )}
                        </div>
                        <button
                            onClick={() => setIsMenuOpen(!isMenuOpen)}
                            className="p-2 text-ps-blue hover:text-ps-blue-dark mr-2"
                        >
                            {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
                        </button>
                    </div>
                </div>

                {/* Desktop Navigation */}
                <nav className="hidden md:flex gap-10 pb-4">
                    {navLinks.map(link => (
                        <Link
                            key={link.to}
                            to={link.to}
                            className="text-ps-blue hover:text-ps-blue-dark transition-colors"
                        >
                            {link.label}
                        </Link>
                    ))}
                </nav>

                {/* Mobile Navigation */}
                {isMenuOpen && (
                    <nav className="md:hidden py-4 flex flex-col space-y-4 border-t">
                        {navLinks.map(link => (
                            <Link
                                key={link.to}
                                to={link.to}
                                className="text-ps-blue hover:text-ps-blue-dark transition-colors block"
                            >
                                {link.label}
                            </Link>
                        ))}
                        <button
                            onClick={handleLogout}
                            className="flex items-center gap-2 text-ps-blue hover:text-ps-blue-dark transition-colors"
                        >
                            <LogOut size={20} />
                            <span>Uitloggen</span>
                        </button>
                    </nav>
                )}
            </div>
            <div className="h-[10px] line-background" />
        </header>
    );
};

export default Header;